﻿import React from 'react';
import { Icon_Warning } from '@Elements/ImageElements/Icons';
import { str_isEmpty } from '@Util/Utils';

import { Form_Error_Message_Props } from '@Util/Types';

export default function Form_Error_Message(props: Form_Error_Message_Props): JSX.Element {
    function generate_element_class(): string {
        let class_str: string = "Form_Row";

        if (!str_isEmpty(props?.className)) {
            class_str += ` ${props.className}`;
        }

        if (props.error) {
            class_str += " Form_Row--Error";
        }

        return class_str;
    }

    if (str_isEmpty(props?.text)) {
        return;
    }

    return (
        <div className={generate_element_class()}>
            <div className="Form_Error_Message">
                <Icon_Warning />
                <p className="Normal">{props.text}</p>
            </div>
        </div>
    )
}